import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import { Modal } from 'react-bootstrap';

import moment from 'moment';

import InfoBox from './info';
import Auth from './auth';

import Patient from './steps/patient';
import Confirmation from './steps/confirm';

import BotModal from '../botPage/modal';
import { useAppointmentApi } from './api';
import { NavLink } from 'react-router-dom';
export default function Appointment({
  appointment,
  auth,
  clearAuthState,
  doctor,
  job,
  isOpen,
  makeAnAppointment,
  makeReservation,
  onClose,
  patients,
  timeSlot,
  updateAppointmentState,
  user,
  getDoctorSchedule,
  getDoctorsByDaysSchedule,
  syncBot,
  isVaccinates,
  fetchPatients,
  isOperator,
  findOperatorPatients,
  makeAnOperatorAppointment,
  makeAnOperatorReservation,
  websiteCovidSource,
  showSearchBtn = false,
  jobDoctorScheduleDays = null,
  searchFilters = null,
}) {
  const {
    register,
    handleSubmit,
    watch,
    control,
    formState: { errors: formErrors },
    trigger,
  } = useForm({
    reValidateMode: 'onBlur',
    defaultValues: {
      reserv_comment: isVaccinates ? 'Вацинація від Covid-19' : '',
    },
  });

  const {
    isVisibleModalBot,
    onSubmit,
    handleClose,
    setIsVisibleModalBot,
    isOperatorChooseOtherPatient,
    handleClearAppointmentState,
    referralNumber,
    setReferralNumber,
  } = useAppointmentApi({
    appointment,
    doctor,
    timeSlot,
    onClose,
    clearAuthState,
    getDoctorSchedule,
    fetchPatients,
    getDoctorsByDaysSchedule,
    updateAppointmentState,
    makeAnAppointment,
    makeReservation,
    isVaccinates,
    isOperator,
    findOperatorPatients,
    makeAnOperatorAppointment,
    makeAnOperatorReservation,
    websiteCovidSource,
    jobDoctorScheduleDays,
  });
  
  const [paymentSuccessful, setPaymentSuccessful] = useState(false);
  const RenderComponent = appointment.success ? Confirmation : Patient;
  const shouldShowInfoBox = !appointment.data?.order && !paymentSuccessful;
  
  if(timeSlot?.block_record_online) {
    return (
      <>
        {isOpen ? (
          <Modal show={isOpen} onHide={handleClose} centered className="appointment-modal" id="appointment">
            <Modal.Header closeButton>
              <Modal.Title>Запис на прийом</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div className="ban-record-online-message institution">
                <p className='doctor-absent-notice pt-4 mobile-notification-title'>{timeSlot?.block_record_reason || 'Запис на прийом тимчасово недоступний. Будь ласка, зверніться до адміністратора медичного закладу для отримання додаткової інформації.'}</p>
              </div>
            </Modal.Body>
          </Modal>
        ) : null}
      </>
    );
  }
  
  return (
    <>
      {isOpen ? (
        <Modal show={isOpen} onHide={handleClose} centered className="appointment-modal" id="appointment">
          <Modal.Header closeButton>
            <Modal.Title>
              {appointment.data?.order?.number 
                ? `Замовлення ${appointment.data.order.number}` 
                : 'Підтвердження запису на прийом'
              }
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <hr className="header-line" />
            
            {shouldShowInfoBox && (!searchFilters?.screening_40_plus || !appointment.success) && (
              <InfoBox
                operatorPatientsLoaded={appointment.operatorPatientsLoaded}
                operatorPatients={appointment.operatorPatients}
                isOperator={isOperator}
                watch={watch}
                declarationSigned={user.declarationSigned}
                doctor={doctor}
                phone={auth.phone}
                timeSlot={timeSlot}
                user={user}
                job={job}
                searchFilters={searchFilters}
              />
            )}
            {user.token || isOperator ? (
              <RenderComponent
                control={control}
                handleSubmit={handleSubmit}
                register={register}
                onClose={handleClose}
                user={user}
                error={appointment.error}
                patientId={appointment.patientId}
                patients={patients}
                timeSlot={timeSlot}
                time={moment(timeSlot.datetime).format('HH:mm')}
                watch={watch}
                isOperator={isOperator}
                operatorPatients={appointment.operatorPatients}
                operatorPatientsLoaded={appointment.operatorPatientsLoaded}
                isOperatorChooseOtherPatient={isOperatorChooseOtherPatient}
                updateAppointmentState={handleClearAppointmentState}
                onSubmit={onSubmit}
                referralNumber={referralNumber}
                setReferralNumber={setReferralNumber}
                formErrors={formErrors}
                trigger={trigger}
                doctor={doctor}
                job={job}
                showSearchBtn={showSearchBtn}
                searchFilters={searchFilters}
                appointment={appointment}
                paymentSuccessful={paymentSuccessful}
                setPaymentSuccessful={setPaymentSuccessful}
              />
            ) : (
              <Auth
                auth={auth}
                referralNumber={referralNumber}
                setReferralNumber={setReferralNumber}
                timeSlot={timeSlot}
                denyRedirect
              />
            )}
          </Modal.Body>
        </Modal>
      ) : null}

      {user.declarationSigned && (
        <BotModal
          isOpen={user.showBotPopup && isVisibleModalBot}
          onClose={() => setIsVisibleModalBot(false)}
          syncBot={syncBot}
        />
      )}
    </>
  );
}
